import { useMemo } from "react";
import FilterBar from "./FilterBar";

function stars(r) {
  if (!r) return "☆☆☆☆☆";
  const f = Math.floor(r), h = r % 1 >= 0.5;
  return "★".repeat(f) + (h ? "½" : "") + "☆".repeat(5 - f - (h ? 1 : 0));
}

function ProductCard({ product, onCTAClick }) {
  return (
    <article className="product-card" aria-label={product.title}>
      {product.badge && <span className="p-badge">{product.badge}</span>}
      <div className="p-img">
        {product.imageUrl
          ? <img src={product.imageUrl} alt={product.title} loading="lazy" width="300" height="300" />
          : <span style={{fontSize:"3rem"}}>📦</span>
        }
      </div>
      <div className="p-body">
        <div className="p-brand">{product.brand}</div>
        <h2 className="p-title">{product.title}</h2>

        {product.rating && (
          <div className="p-rating">
            <span className="p-stars" aria-label={`${product.rating} stars`}>{stars(product.rating)}</span>
            <span className="p-rcount">({(product.reviewCount||0).toLocaleString()})</span>
          </div>
        )}

        {product.price && (
          <div>
            <span className="p-price">£{product.price.toFixed(2)}</span>
            {product.originalPrice && (
              <span className="p-orig">£{product.originalPrice.toFixed(2)}</span>
            )}
          </div>
        )}

        {product.benefitCopy && <p className="p-benefit">{product.benefitCopy}</p>}

        <div className="p-cta">
          <a
            href={product.affiliateUrl}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="p-cta-btn"
            onClick={() => onCTAClick?.(product)}
          >
            View on Amazon →
          </a>
          <p className="p-aff-note">
            🔗 Affiliate link · As an Amazon Associate I earn from qualifying purchases
          </p>
        </div>
      </div>
    </article>
  );
}

export default function ProductGrid({ products = [], onCTAClick }) {
  const [filters, setFilters] = useMemo(() => {
    // ProductGrid manages its own filter state
    return [null, null];
  }, []); // eslint-disable-line

  // Let the parent page manage filters — just render
  if (!products.length) {
    return (
      <div className="empty-state">
        <div className="empty-icon">🔍</div>
        <p>No products match your current filters.</p>
      </div>
    );
  }

  return (
    <div className="product-grid" aria-label="Product listings">
      {products.map(p => (
        <ProductCard key={p.asin} product={p} onCTAClick={onCTAClick} />
      ))}
    </div>
  );
}
